import { connect } from 'react-redux';
import { ManageLocationsComponent } from './manage-locations.component';
import { AppState } from '../../app.state';

export const ManageLocations = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageLocationsComponent as any
) as unknown as typeof ManageLocationsComponent;
